/* Kits del taller en el carrito:
 * - "Eliminar kit": borra TODOS los line items que comparten _KitID (una sola
 *   llamada a /cart/update.js usando las keys de línea) — los items de kit no
 *   tienen bote de basura individual porque el ensamble se usa completo.
 * - Resumen técnico: dibuja el ensamble (mf-assembler.js) + cota punteada con
 *   la longitud, leyendo los data-attrs que emite main-cart.liquid.
 */
(function () {
  if (window.__mfKitCart) return;
  window.__mfKitCart = true;

  function angleOf(title) {
    var t = (title || '').toLowerCase();
    if (/codo[^0-9]*90/.test(t)) return '90';
    if (/codo[^0-9]*45/.test(t)) return '45';
    if (/codo/.test(t)) return '45'; // 22.5/30/60/67.5: sigue siendo codo, nunca 'recta'
    return 'recta';
  }
  function genderOf(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('hembra') >= 0) return 'hembra';
    if (t.indexOf('macho') >= 0) return 'macho';
    return null;
  }

  function renderSummaries() {
    if (typeof window.buildAssemblySVG !== 'function') return;
    document.querySelectorAll('.mf-kit-summary').forEach(function (box) {
      var kid = box.getAttribute('data-mf-kit-id');
      var canvas = box.querySelector('[data-mf-canvas]');
      var dim = box.querySelector('[data-mf-dim]');
      if (!canvas || canvas.getAttribute('data-mf-done') === kid) return;

      var rows = document.querySelectorAll('tr.mf-kit-item');
      var parts = [];
      rows.forEach(function (r) {
        if (r.getAttribute('data-mf-kit-id') !== kid) return;
        var loc = r.getAttribute('data-mf-loc') || '';
        var title = r.getAttribute('data-mf-title') || '';
        var role = null;
        if (loc === 'Extremo A') role = 'fitA';
        else if (loc === 'Extremo B') role = 'fitB';
        else if (loc === 'Adaptador A') role = 'adpA';
        else if (loc === 'Adaptador B') role = 'adpB';
        if (role) parts.push({ role: role, angle: angleOf(title), gender: genderOf(title), img: r.getAttribute('data-mf-img') || '' });
      });
      if (!parts.length) return;

      // v6: fotos reales de los productos + manguera Aeroquip; si falla cae al SVG
      canvas.setAttribute('data-mf-done', kid);
      if (typeof window.renderAssemblyPhoto === 'function') window.renderAssemblyPhoto(canvas, parts, {});
      else canvas.innerHTML = window.buildAssemblySVG(parts, {});

      if (dim) {
        var len = dim.getAttribute('data-len') || '';
        var isEn = (document.documentElement.lang || '').indexOf('en') === 0;
        dim.innerHTML = len
          ? '<div class="dim"><span class="cap l"></span><span class="cap r"></span><span class="dim-label">' +
            (isEn ? 'Assembly length: ' : 'Longitud del ensamble: ') + len.replace(/</g, '&lt;') + '</span></div>'
          : '';
      }
    });
  }

  function removeKit(btn) {
    var kid = btn.getAttribute('data-mf-kit-id');
    if (!kid) return;
    var updates = {};
    document.querySelectorAll('[data-mf-kit-id][data-mf-key]').forEach(function (r) {
      if (r.getAttribute('data-mf-kit-id') === kid) updates[r.getAttribute('data-mf-key')] = 0;
    });
    if (!Object.keys(updates).length) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    // Siempre el endpoint .js: routes.cart_update_url apunta a /cart/update (HTML)
    // y aunque borra, la respuesta no es JSON y el flujo truena sin recargar.
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'cart/update.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart update failed ' + r.status); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        btn.disabled = false; btn.classList.remove('is-loading');
        console.error('[mf-kit-cart]', err);
        alert('No se pudo eliminar el kit. Intenta de nuevo.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mf-kit-remove');
    if (!btn) return;
    e.preventDefault();
    removeKit(btn);
  });

  // Render inicial + re-render cuando cart.js reemplaza el HTML por AJAX
  function boot() {
    renderSummaries();
    var host = document.getElementById('main-cart-items');
    if (host && !host.__mfObserved) {
      host.__mfObserved = true;
      new MutationObserver(function () { renderSummaries(); }).observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // mf-assembler.js puede cargar después (defer): reintenta breve
  var tries = 0;
  var iv = setInterval(function () {
    if (typeof window.buildAssemblySVG === 'function' || ++tries > 40) { clearInterval(iv); renderSummaries(); }
  }, 250);
})();
